"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AddArticle = AddArticle;
exports.DelArticle = DelArticle;
exports.ListArticle = ListArticle;
exports.UpdateArticle = UpdateArticle;
exports.UpdateStatus = UpdateStatus;
exports.createHouse = createHouse;
exports.deleteHouse = deleteHouse;
exports.detailHouse = detailHouse;
exports.getComDetail = getComDetail;
exports.houseLists = houseLists;
exports.updateHouse = updateHouse;
var _request = _interopRequireDefault(require("@/utils/request"));
var _requestMapi = _interopRequireDefault(require("@/utils/requestMapi"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; } // +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2021 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------
/**
 * 列表
 * @param pram
 * @constructor
 */
function ListArticle() {
  var pram = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _ref = pram.addressId || [],
    _ref2 = _slicedToArray(_ref, 3),
    provinceId = _ref2[0],
    cityId = _ref2[1],
    districtId = _ref2[2];
  var data = {
    name: pram.name,
    taxId: pram.taxId,
    provinceId: provinceId,
    cityId: cityId,
    districtId: districtId,
    platformId: pram.platformId,
    page: pram.page,
    limit: pram.limit
  };
  return (0, _requestMapi.default)({
    url: '/mapi/user/company/list',
    method: 'GET',
    params: data
  });
}
var handSubmit = function handSubmit() {
  var datas = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var name = datas.name,
    taxId = datas.taxId,
    _datas$addressId = datas.addressId,
    addressId = _datas$addressId === void 0 ? [] : _datas$addressId,
    address = datas.address,
    status = datas.status,
    weChatGroupName = datas.weChatGroupName,
    remark = datas.remark;
  var _ref3 = addressId || [],
    _ref4 = _slicedToArray(_ref3, 3),
    provinceId = _ref4[0],
    cityId = _ref4[1],
    districtId = _ref4[2];
  return {
    provinceId: provinceId,
    cityId: cityId,
    districtId: districtId,
    address: address,
    status: status,
    weChatGroupName: weChatGroupName,
    remark: remark,
    name: name,
    taxId: taxId
  };
};

/**
 * 新增
 * @param pram
 * @constructor
 */
function AddArticle(pram) {
  return (0, _requestMapi.default)({
    url: '/mapi/user/company/save',
    method: 'post',
    data: handSubmit(pram)
  });
}

/**
 * 更新
 * @param pram
 * @constructor
 */
function UpdateArticle(pram) {
  return (0, _requestMapi.default)({
    url: '/mapi/user/company/update',
    method: 'post',
    data: _objectSpread(_objectSpread({}, handSubmit(pram)), {}, {
      id: pram.id
    })
  });
}

/**
 * 更新
 * @param pram
 * @constructor
 */
function UpdateStatus(pram) {
  return (0, _requestMapi.default)({
    url: '/mapi/user/company/updateStatus',
    method: 'post',
    data: _objectSpread(_objectSpread({}, handSubmit(pram)), {}, {
      id: pram.id
    })
  });
}

/**
 * 删除
 * @param id
 * @constructor
 */
function DelArticle(id) {
  return (0, _requestMapi.default)({
    url: '/mapi/user/company/delete',
    method: 'GET',
    params: id
  });
}

/**
 * 详情
 * @param id
 * @constructor
 */
function getComDetail(id) {
  return (0, _requestMapi.default)({
    url: '/mapi/user/company/detail',
    method: 'GET',
    params: {
      id: id
    }
  });
}

// 家政-----------------------------------------------------------------
/**
 * 列表
 */
function houseLists() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return (0, _requestMapi.default)({
    url: '/mapi/thirdparty/domestic-store/list',
    method: 'GET',
    params: params
  });
}

/**
 * 创建
 */
function createHouse() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return (0, _requestMapi.default)({
    url: '/mapi/thirdparty/domestic-store/save',
    method: 'post',
    data: data
  });
}

/**
 * 更新
 */
function updateHouse() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return (0, _requestMapi.default)({
    url: '/mapi/thirdparty/domestic-store/update',
    method: 'put',
    data: data
  });
}

/**
 * 删除
 */
function deleteHouse(id) {
  return (0, _requestMapi.default)({
    url: "/mapi/thirdparty/domestic-store/delete/".concat(id),
    method: 'GET',
    params: {
      id: id
    }
  });
}

/**
 * 详情
 */
function detailHouse(id) {
  return (0, _requestMapi.default)({
    url: "/mapi/thirdparty/domestic-store/detail/".concat(id),
    method: 'GET',
    params: {
      id: id
    }
  });
}